import { render, staticRenderFns } from "./IconsAndText.vue?vue&type=template&id=68c203a5&"
import script from "./IconsAndText.vue?vue&type=script&lang=js&"
export * from "./IconsAndText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports